import React from 'react';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
var styles = {
  details: {
    textAlign: 'center',
    padding: '8px 0',
    backgroundColor: '#eee'
  },
  rowBackground: {
    backgroundColor: '#fff'
  }
};

var PanelDetails = function PanelDetails(props) {
  var renderPanelCells = function renderPanelCells(cells) {
    return cells.map(function (cell, i) {
      return React.createElement(Grid, {
        item: true,
        xs: 3,
        key: i,
        "data-testid": "panel-".concat(i)
      }, cell.get('value'));
    });
  };

  return props.rows.map(function (row, i) {
    var bgClass = '';

    if (i % 2) {
      bgClass = ' ' + props.classes.rowBackground;
    }

    return React.createElement(Grid, {
      container: true,
      className: "".concat(props.classes.details).concat(bgClass),
      key: i,
      "data-testid": "details-".concat(i)
    }, renderPanelCells(row));
  });
};

export default withStyles(styles)(PanelDetails);